import {req,importFile } from './axiosFun';



export const qryDomCate = (params) => { return req("post", "/huichen-ui/document/qryDomCate", params) };
export const addDomCate = (params) => { return req("post", "/huichen-ui/document/addDomCate", params) };
export const upDomCate = (params) => { return req("post", "/huichen-ui/document/upDomCate", params) };
export const delDomCate = (params) => { return req("post", "/huichen-ui/document/delDomCate", params) };
export const delDomCatePl = (params) => { return req("post", "/huichen-ui/document/delDomCatePl", params) };
export const qryDomInfo = (params) => { return req("post", "/huichen-ui/document/qryDomInfo", params) };
export const addDomInfo = (params) => { return req("post", "/huichen-ui/document/addDomInfo", params) };
export const upDomInfo = (params) => { return req("post", "/huichen-ui/document/upDomInfo", params) };
export const delDomInfo = (params) => { return req("post", "/huichen-ui/document/delDomInfo", params) };
export const delDomInfoPl = (params) => { return req("post", "/huichen-ui/document/delDomInfoPl", params) };
export const qryDomComment = (params) => { return req("post", "/huichen-ui/document/qryDomComment", params) };
export const upDomComment = (params) => { return req("post", "/huichen-ui/document/upDomComment", params) };
export const delDomComment = (params) => { return req("post", "/huichen-ui/document/delDomComment", params) };
export const delDomCommentPl = (params) => { return req("post", "/huichen-ui/document/delDomCommentPl", params) };
export const downloadDomInfo = (params) => { return importFile("post", "/huichen-ui/document/downloadDomInfo", params) };


export const qryAboutInfo = (params) => { return req("post", "/huichen-ui/document/qryAboutInfo", params) };
export const addAboutInfo = (params) => { return req("post", "/huichen-ui/document/addAboutInfo", params) };
export const upAboutInfo = (params) => { return req("post", "/huichen-ui/document/upAboutInfo", params) };
export const delAboutInfo = (params) => { return req("post", "/huichen-ui/document/delAboutInfo", params) };
export const qryParamHuo = (params) => { return req("post", "/huichen-ui/document/qryParamHuo", params) };
export const upParamHuo = (params) => { return req("post", "/huichen-ui/document/upParamHuo", params) };
export const upDomCommentPl = (params) => { return req("post", "/huichen-ui/document/upDomCommentPl", params) };



// WEBPACK FOOTER //
// ./src/api/dom.js